import { useMutation, useQueryClient } from 'react-query';

import { deleteV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId } from 'src/client/spendesk-api';
import { useCompany } from 'src/core/modules/app/hooks/useCompany';

import { getApiKey } from './keys';

export const useDeleteBudgetDefinition = (budgetDefinitionId: string) => {
  const company = useCompany();
  const queryClient = useQueryClient();
  return useMutation(
    getApiKey([budgetDefinitionId]),
    async () => {
      const response =
        await deleteV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId({
          path: {
            companyId: company.id,
            budgetDefinitionId,
          },
        });

      if (response.statusCode !== 204) {
        throw new Error('Failed to get budget definitions');
      }
    },
    {
      retry: false,
      onSuccess: () => {
        queryClient.invalidateQueries(getApiKey([budgetDefinitionId]));
        queryClient.invalidateQueries(getApiKey());
      },
    },
  );
};
